import { Trans } from '@ui/i18n/trans';
import imgUrl1 from './404-1.png';
import imgUrl2 from './404-2.png';

export function NotFoundPage() {
  return (
    <div className="isolate flex flex-col-reverse items-center justify-center gap-16 px-4 py-24 md:gap-28 md:px-44 md:py-20 lg:flex-row lg:px-24 lg:py-24">
      
      {/* Left Content */}
      <div className="relative w-full pb-12 lg:pb-0 xl:w-1/2 xl:pt-24">
        <div className="relative">
          <div className="absolute">
            <div className="relative z-10">
              
              <h1 className="my-2 text-2xl font-bold text-foreground">
                <Trans message="Page Not Found" />
              </h1>

              <p className="my-4 text-foreground">
                <Trans
                  message="Sorry, the page you are looking for does not exist or has been moved."
                />
              </p>

            </div>
          </div>

          <div className="dark:opacity-5">
            <img src={imgUrl2 as any} alt="background illustration" />
          </div>
        </div>
      </div>

      {/* Right Image */}
      <div className="dark:opacity-80">
        <img src={imgUrl1 as any} alt="status illustration" />
      </div>

    </div>
  );
}